import axios from 'axios';
import { ComponentType, SVGProps, useEffect, useState } from 'react';

const numberFormat = new Intl.NumberFormat('pt-BR');

type TechnologyOverviewCountCardProps = {
  label: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  iconClassName: string;
  load: () => Promise<number>;
};

export function TechnologyOverviewCountCard({
  label,
  icon: Icon,
  iconClassName,
  load,
}: TechnologyOverviewCountCardProps) {
  const [value, setValue] = useState<number | null>(null);
  const [state, setState] = useState<'loading' | 'ready' | 'denied' | 'error'>('loading');

  useEffect(() => {
    let cancelled = false;
    setState('loading');
    void load()
      .then((count) => {
        if (cancelled) return;
        setValue(count);
        setState('ready');
      })
      .catch((error: unknown) => {
        if (cancelled) return;
        const status = axios.isAxiosError(error) ? error.response?.status : undefined;
        setState(status === 403 ? 'denied' : 'error');
      });
    return () => {
      cancelled = true;
    };
  }, [load]);

  const text =
    state === 'loading' ? '…' : state === 'ready' && value != null ? numberFormat.format(value) : '—';
  const hint =
    state === 'denied'
      ? 'Sem acesso a este módulo'
      : state === 'error'
        ? 'Não foi possível carregar'
        : undefined;

  return (
    <article
      className="flex items-center gap-3 rounded-2xl border border-secondary-200 bg-white px-4 py-3 shadow-sm"
      title={hint}
    >
      <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${iconClassName}`}>
        <Icon className="h-5 w-5" aria-hidden="true" />
      </span>
      <span className="min-w-0">
        <span className="block text-2xl font-semibold leading-none text-secondary-900">{text}</span>
        <span className="mt-1 block truncate text-sm text-secondary-500">{label}</span>
      </span>
    </article>
  );
}
